import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { Button } from 'components/cosmos';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import './ErrorCard.scss';

const ErrorCard = ({ t, text, onClick, className }) => {
  const containerClass = classnames('error_card', className);

  return (
    <div data-test="error-container" className={containerClass}>
      <div className="error_card__text" data-test="error-text">
        {text || t('dashboard.error_loading')}
      </div>
      <Button
        variation="secondary"
        onClick={onClick}
        className="error_card__buton"
        data-test="error-button"
        aria-label={t('general.retry')}
      >
        <FontAwesomeIcon icon="rotate-right" />
      </Button>
    </div>
  );
};

ErrorCard.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  iconSize: PropTypes.number,
  onClick: PropTypes.func
};

export default translate()(ErrorCard);
